import React from 'react';
import { FadeIn } from './FadeIn';
import { Flame, BatteryWarning, Footprints, AlertCircle } from 'lucide-react';
export function StorySection() {
  return <section className="py-20 bg-white" data-id="element-184">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-185">
        {/* Opening Hook */}
        <FadeIn data-id="element-186">
          <div className="text-center mb-16" data-id="element-187">
            <Flame className="w-12 h-12 text-orange-500 mx-auto mb-6 opacity-80" data-id="element-188" />
            <p className="text-2xl md:text-3xl font-serif text-forest leading-relaxed mb-8" data-id="element-189">
              ¿Te ha pasado que al despertar sientes los dedos de las manos
              endurecidos o las rodillas tan pesadas que parece que caminas
              sobre cemento?
            </p>
            <p className="text-lg text-gray-600 mb-6 font-medium" data-id="element-190">
              No es la edad. No es solo cansancio. Es el{' '}
              <span className="text-red-500 font-bold" data-id="element-191">
                "incendio silencioso"
              </span>{' '}
              de la inflamación celular consumiendo tu energía desde adentro.
            </p>
            <p className="text-gray-600" data-id="element-192">
              La mayoría de nosotros intenta apagar ese fuego con pastillas que
              solo adormecen el dolor por unas horas, mientras el verdadero
              problema —el desequilibrio de agua y sales en tus células— sigue
              empeorando.
            </p>
          </div>
        </FadeIn>

        {/* The Problem */}
        <div className="bg-sand/30 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-193">
          <div className="absolute top-0 right-0 w-32 h-32 bg-forest/5 rounded-bl-full" data-id="element-194" />

          <FadeIn delay={0.2} data-id="element-195">
            <h3 className="text-2xl md:text-3xl font-bold text-forest mb-8 text-center" data-id="element-196">
              Vivir inflamado es como intentar correr un maratón con una mochila
              llena de piedras.
            </h3>
          </FadeIn>

          <div className="grid md:grid-cols-3 gap-8 mb-10" data-id="element-197">
            <FadeIn delay={0.3} className="bg-white p-6 rounded-2xl shadow-sm border border-sand" data-id="element-198">
              <BatteryWarning className="w-8 h-8 text-orange-400 mb-4" data-id="element-199" />
              <p className="text-gray-700 text-sm" data-id="element-200">
                Te despiertas ya cansado, sin energía para empezar el día.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} className="bg-white p-6 rounded-2xl shadow-sm border border-sand" data-id="element-201">
              <AlertCircle className="w-8 h-8 text-orange-400 mb-4" data-id="element-202" />
              <p className="text-gray-700 text-sm" data-id="element-203">
                Te miras al espejo y ves tu rostro hinchado y sin brillo.
              </p>
            </FadeIn>

            <FadeIn delay={0.5} className="bg-white p-6 rounded-2xl shadow-sm border border-sand" data-id="element-204">
              <Footprints className="w-8 h-8 text-orange-400 mb-4" data-id="element-205" />
              <p className="text-gray-700 text-sm" data-id="element-206">
                Para el mediodía, tus zapatos te aprietan porque tus tobillos
                han retenido cada gota de líquido.
              </p>
            </FadeIn>
          </div>

          <FadeIn delay={0.6} data-id="element-207">
            <p className="text-gray-700 leading-relaxed text-center max-w-2xl mx-auto" data-id="element-208">
              En nuestra cultura latina, hemos crecido comiendo aceites
              vegetales procesados y excesos de harinas que bloquean la
              capacidad de tus células para "respirar". El resultado es una
              célula hinchada, tóxica y lenta que te hace sentir{' '}
              <strong className="text-forest" data-id="element-209">
                20 años mayor de lo que realmente eres.
              </strong>
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}